import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all } from "../../../../lib/v31lib";
// import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import GroupIcon from '@mui/icons-material/Group';
import SearchIcon from '@mui/icons-material/Search';
import VideoCallIcon from '@mui/icons-material/VideoCall';

import {
  Box,
  Chip,
  Grid,
  List,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Button,
  Typography
} from '../../../../components/v2/styled';
import { ListItemAppointmentType } from '../../../../components/v2/list_items/AppointmentType';

import { AppointmentType } from '../../../../models/AppointmentType';
import { Location } from '../../../../models/Location';
import { Practice } from '../../../../models/Practice';
import { User } from '../../../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  selectedType?: AppointmentType;
  setSelectedType: (d:AppointmentType|undefined) => void;
  activeCoach?: User;
  activeLocation?: Location;
  activePractice?: Practice;
}

export const ClientAppointmentNewStepType: FunctionComponent<Props> = ({activePractice, selectedType, setSelectedType, activeCoach, activeLocation}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  // const matchesmd = useMediaQuery(theme.breakpoints.up('md'));

  // const [currentDay, setCurrentDay] = useState<string>(!!state && !!state.day ? state.day : DateTime.now().toFormat("dd/LL/y"));
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [activeCategory, setActiveCategory] = useState<string>('');
  let hasVideo = false;
  let hasPhysical = false;

  const {
    data: appointmentTypes,
    // isLoading: appointmentTypesLoading,
    // isError: appointmentTypesError,
    isSuccess: appointmentTypesSuccess,
    refetch: appointmentTypesRefetch,
  } = useQuery({
    queryKey: ["appointment_types", activePractice?.id],
    queryFn: () =>
      fetch_all<AppointmentType>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'appointment_type',
          fields: [
            'id', 'name', 'get_name', 'duration', 'duration_nice', 'public_duration', 'public_duration_nice', 'is_meeting', 'colour', 'cost', 'coaches', 'mollie', 'note_required', 'extra_data', 'subtype'
          ],
          page: 0,
          per_page: 1000,
          order: "sort_order ASC, name ASC",
          filter: {
            search: '',
            advanced: {
              practice_id: activePractice?.id,
              enabled: 1,
              visible: 1
            }
          }
        }
      ),
    select: (d) => {
      hasVideo = d.filter(ff => ff.is_meeting).length > 0;
      hasPhysical = d.filter(ff => !ff.is_meeting).length > 0;
      return d;
    },
    enabled: !!activePractice?.id,
  });





  useEffect(() => {
    appointmentTypesRefetch();
  }, [i18n.resolvedLanguage]);
  
  return <Paper sx={{
    padding: 2
  }}>
    <Box>
      {!selectedType && <Box sx={{
        marginBottom: 3,
        '& .Mui-selected': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }
      }}>
        <Tabs
          value={currentTab}
          onChange={(e, v) => {setCurrentTab(v);}}
          indicatorColor="primary"
          textColor="primary"
          aria-label="Filters"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab icon={<AllInclusiveIcon />} label={t("client.appointment.type_filter_option.all")} />
          {hasVideo && <Tab icon={<VideoCallIcon />} label={t("client.appointment.type_filter_option.video")} />}
          {hasPhysical && <Tab icon={<GroupIcon />} label={t("client.appointment.type_filter_option.physical")} />}
        </Tabs>
      </Box>}

      {!!selectedType && <>
        <Typography variant={"subtitle2"}>{t("client.appointment.selected_type")}:</Typography>
        <List>
          <ListItemAppointmentType type={selectedType} />
        </List>
        <Button
          id="unselect"
          label={t("client.appointment.unpick_type")}
          onClick={() => {
            setSelectedType(undefined);
          }}
          text
          size='small'
          sx={{
            marginTop: 1
          }}
        />
      </>}

      {/* {(this.props.login && !activePractice?.id) && <React.Fragment>
        <Typography variant={"subtitle2"}>{t("client.appointment.find_practice_before_appointment")}</Typography><br />
        <Button sx={{
          '& svg': {
            marginRight: 8,
            color: "rgba(0, 0, 0, 0.54)"
          }
        }} onClick={(e) => {this.props.history.push('/find');}} variant="contained" color="primary">
          <SearchIcon />
          {t("client.menu.find", "Praktijk zoeken")}
        </Button>
      </React.Fragment>} */}

      {!activePractice?.id && <>
        <Typography variant={"subtitle2"}>{t("client.appointment.find_practice_before_appointment")}</Typography><br />
        <Button
          onClick={(e) => {navigate('/find');}}
          contained
          id="find"
          startIcon={<SearchIcon />}
          label={t("client.menu.find", "Praktijk zoeken")}
        />
      </>}

      {!!activePractice?.id && appointmentTypesSuccess && !selectedType && <>
        {appointmentTypes.length > 1 && <Typography variant={"subtitle2"}>{t("client.appointment.pick_type")}:</Typography>}
        {appointmentTypes.filter(fff => !!fff.subtype).length > 0 && <Grid item xs={12} sx={{textAlign: 'left'}}>
          <Chip
            label={t("coach.models.appointment_types.subtypes.first_time_short")}
            variant={activeCategory === "first_time" ? "filled" : "outlined"}
            onDelete={activeCategory === "first_time" ? () => {
              if (activeCategory !== "first_time") setActiveCategory("first_time");
              if (activeCategory === "first_time") setActiveCategory('');
            } : undefined}
            onClick={() => {
              if (activeCategory !== "first_time") setActiveCategory("first_time");
              if (activeCategory === "first_time") setActiveCategory('');
            }}
            sx={{
              borderColor: theme.palette.tertiary?.main,
              marginLeft: 0.5,
              ...(activeCategory === "first_time" ? {
                backgroundColor: theme.palette.tertiary?.main,
                "&:hover": {
                  backgroundColor: theme.palette.tertiary?.main,
                }
              } : {})
            }}
          />
          <Chip
            label={t("coach.models.appointment_types.subtypes.continuation_short")}
            variant={activeCategory === "continuation" ? "filled" : "outlined"}
            onDelete={activeCategory === "continuation" ? () => {
              if (activeCategory !== "continuation") setActiveCategory("continuation");
              if (activeCategory === "continuation") setActiveCategory('');
            } : undefined}
            onClick={() => {
              if (activeCategory !== "continuation") setActiveCategory("continuation");
              if (activeCategory === "continuation") setActiveCategory('');
            }}
            sx={{
              borderColor: theme.palette.tertiary?.main,
              marginLeft: 0.5,
              ...(activeCategory === "continuation" ? {
                backgroundColor: theme.palette.tertiary?.main,
                "&:hover": {
                  backgroundColor: theme.palette.tertiary?.main,
                }
              } : {})
            }}
          />
        </Grid>}
        <List>
          {appointmentTypes.filter(ff => ((
            currentTab === 0 || ( // everything
              currentTab === 1 && hasVideo && ff.is_meeting // only video
            ) || (
              currentTab === 2 && hasPhysical && !ff.is_meeting // only phys
            ) || (
              currentTab === 1 && !hasVideo && !ff.is_meeting // only phys if no video present
            )
          ))).filter(fff => !activeCoach || (fff.coaches || []).length === 0 || (!!activeCoach && (fff.coaches || []).indexOf(activeCoach.id || 0) < 0)).filter(fff => (!activeCategory || (!!activeCategory && fff.subtype === activeCategory))).map(type => (<>
            {(!selectedType) && <ListItemAppointmentType type={type} onClick={() => {
              setSelectedType(type);
            }} />}
          </>))}
        </List>
      </>}
    </Box>
  </Paper>;
}

